<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.settings') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content regional-settings-form ">
        <el-form
          :model="form"
          :rules="rules"
          label-position="left"
          ref="form"
          v-loading="loading"
        >
          <el-form-item
            :label="
              $t('text.organisation').toLowerCase() | firstLetterCapitalize
            "
          >
            {{ $store.getters[`user/selecteOrganisationName`] }}
          </el-form-item>
          <div class="sub-title">
            {{ $t('text.basic_settings') }}
          </div>
          <el-form-item :label="$t('text.language')" prop="Language">
            <el-radio-group
              v-model="form.Language"
              @input="handleLanguageChange()"
            >
              <el-radio
                v-for="item in languageList"
                :label="item.value"
                :key="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('text.time_zone')" prop="TimeZone">
            <el-select v-model="form.TimeZone" filterable>
              <el-option
                v-for="item in timeZoneList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('text.date_time_format')"
            prop="DateTimeFormat"
          >
            <el-select v-model="form.DateTimeFormat" filterable>
              <el-option
                v-for="item in dateTimeFormatOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.measure_unit')" prop="MeasuringUnit">
            <el-radio-group v-model="form.MeasuringUnit">
              <el-radio
                v-for="item in measureUnitOptions"
                :label="item.value"
                :key="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$t('text.display_time_in_dashboard')"
            prop="IsTimeDisplayEnabled"
          >
            <el-switch v-model="form.IsTimeDisplayEnabled"></el-switch>
          </el-form-item>
          <div class="sub-title">
            {{ $t('text.custom_system_terms') }}
          </div>
          <el-form-item :label="$t('text.term') + ' (Pad)'" prop="Pad">
            <el-radio-group v-model="form.Pad">
              <el-radio
                v-for="item in padOptions"
                :label="item[form.Language]['singular']"
                :key="item[form.Language]['singular']"
                >{{ item[form.Language]['singular'] }}</el-radio
              >
            </el-radio-group>
            <el-radio
              v-model="customPad.enable"
              @change="handCustomPadOptionChange"
              :label="true"
              style="vertical-align: middle;"
              >{{ $t('text.custom') }}</el-radio
            >
            <div v-if="customPad.enable">
              <el-input
                v-model="customPad.value"
                class="ml-5"
                size="small"
                :placeholder="$t('text.singular')"
              >
              </el-input>
              <el-input
                v-model="customPad.pluralValue"
                class="ml-5"
                size="small"
                :placeholder="$t('text.plural')"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            :label="$t('text.term') + ' (Patient)'"
            prop="Patient"
            style="border-bottom: none; margin-bottom: 0;"
          >
            <el-radio-group v-model="form.Patient">
              <el-radio
                v-for="item in patientOptions"
                :label="item[form.Language]['singular']"
                :key="item[form.Language]['singular']"
                >{{ item[form.Language]['singular'] }}</el-radio
              >
            </el-radio-group>
            <el-radio
              v-model="customPatient.enable"
              @change="handCustomPatientOptionChange"
              :label="true"
              style="vertical-align: middle;"
              >custom</el-radio
            >
            <div v-if="customPatient.enable">
              <el-input
                v-model="customPatient.value"
                class="ml-5"
                size="small"
                :placeholder="$t('text.singular')"
              >
              </el-input>
              <el-input
                v-model="customPatient.pluralValue"
                class="ml-5"
                size="small"
                :placeholder="$t('text.plural')"
              >
              </el-input>
            </div>
          </el-form-item>
          <div class="sub-title">
            {{ $t('text.nurse_call_dashboard') }}
          </div>
          <el-form-item
            :label="$t('text.organisation_code')"
            prop="OrganisationCode"
          >
            <div>
              <el-input
                v-model="form.OrganisationCode"
                size="small"
                readonly
              ></el-input>
              <el-button
                type="primary"
                @click="generateNewCode()"
                class="generate-new"
                size="small"
                :loading="generateLoading"
                :disabled="generateLoading"
                >{{ $t('text.generate_new') }}</el-button
              >
            </div>
          </el-form-item>
          <div class="sub-title">
            <span>{{ $t('text.rounds_shifts') }}</span>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              class="ml-15"
              @click="openAddRoundDialog()"
            ></el-button>
          </div>
          <el-table
            border
            size="mini"
            :data="roundsList"
            v-loading="shiftLoading"
          >
            <el-table-column :label="$t('text.name')">
              <template slot-scope="scope">
                {{ scope.row.ShiftName }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('range') | firstLetterCapitalize">
              <template slot-scope="scope">
                {{ scope.row.ShiftStart }} -
                {{ scope.row.ShiftEnd }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('text.action')">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="editRoundItem(scope.row)"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  @click="removeRoundItem(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="mt-20 text-right">
          <el-button
            class="common-btn min-w-80"
            :loading="submitLoading"
            @click="submit()"
            size="medium"
            v-if="p('Organisations.Edit')"
            >{{ $t('text.save').toUpperCase() }}</el-button
          >
          <el-button
            class="cancel-btn min-w-80"
            @click="resetForm()"
            size="medium"
            >{{ $t('text.reset') }}</el-button
          >
        </div>
      </div>
    </div>
    <AddRound ref="addRound" />
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
import AddRound from '@/components/manage/organisation/AddRound'
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      generateLoading: false,
      submitLoading: false,
      timeZoneList: [],
      languageList: [
        {
          value: 'de',
          label: 'Deutsch'
        },
        {
          value: 'en',
          label: 'English'
        },
        {
          value: 'es',
          label: 'Canadian-English'
        },
        {
          value: 'fr',
          label: 'Français'
        },
        {
          value: 'it',
          label: 'Italiano'
        },
        {
          value: 'nl',
          label: 'Nederlands'
        }
      ],
      dateTimeFormatOptions: [],
      measureUnitOptions: [],
      form: {
        Language: this.getInitLanguage(),
        TimeZone: '',
        DateTimeFormat: '',
        MeasuringUnit: '',
        Pad: '',
        Patient: '',
        IsTimeDisplayEnabled: false,
        OrganisationCode: ''
      },
      customPad: {
        enable: false,
        value: '',
        pluralValue: ''
      },
      customPatient: {
        enable: false,
        value: '',
        pluralValue: ''
      },
      padOptions: [],
      patientOptions: [],
      rules: {
        Language: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          }
        ],
        TimeZone: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          }
        ],
        DateTimeFormat: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          }
        ],
        WeightMetric: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          }
        ]
      },
      savedPadTexts: [],
      savedPatientTexts: [],
      roundsList: [],
      shiftLoading: false
    }
  },
  components: {
    AddRound
  },
  mounted() {
    Promise.all([this.getConfigs(), this.getAllLocation()]).then(() => {
      this.getDetail()
      this.getOrganisationSetupCode()
    })
    this.getRounds()
  },
  watch: {
    savedPatientTexts() {
      this.computedFormPatient()
    },
    savedPadTexts() {
      this.computedFormPad()
    },
    'form.Language'() {
      this.computedFormPatient()
      this.computedFormPad()
    },
    'form.Patient'() {
      if (this.form.Patient) {
        this.customPatient = {
          enable: false,
          value: '',
          pluralValue: ''
        }
      }
    },
    'form.Pad'() {
      if (this.form.Pad) {
        this.customPad = {
          enable: false,
          value: '',
          pluralValue: ''
        }
      }
    }
  },
  methods: {
    getInitLanguage() {
      let language = this.$store.state.locale.currentLocale
      if (!language) language = 'en'
      if (language === 'ca') language = 'es'
      return language
    },
    handCustomPatientOptionChange() {
      if (this.customPatient.enable) {
        this.form.Patient = null
      }
    },
    handCustomPadOptionChange() {
      if (this.customPad.enable) {
        this.form.Pad = null
      }
    },
    computedFormPatient() {
      if (!this.savedPatientTexts) return false
      let item = this.savedPatientTexts.filter(item => {
        return item.Language === this.form.Language
      })
      if (!item.length) {
        this.form.Patient = null
        this.customPatient = {
          enable: false,
          value: null,
          pluralValue: null
        }
        return false
      }
      item = item[0]
      let preDefinedOptions = this.patientOptions.map(item => {
        return item[this.form.Language]['singular']
      })

      if (preDefinedOptions.includes(item.PatientValue)) {
        this.form.Patient = item.PatientValue
        this.customPatient = {
          enable: false,
          value: null,
          pluralValue: null
        }
      } else {
        this.form.Patient = null
        this.customPatient = {
          enable: true,
          value: item.PatientValue,
          pluralValue: item.PluralPatientValue
        }
      }
    },
    computedFormPad() {
      if (!this.savedPadTexts) return false
      let item = this.savedPadTexts.filter(item => {
        return item.Language === this.form.Language
      })
      if (!item.length) {
        this.form.Pad = null
        this.customPad = {
          enable: false,
          value: null,
          pluralValue: null
        }
        return false
      }
      item = item[0]
      let preDefinedOptions = this.padOptions.map(item => {
        return item[this.form.Language]['singular']
      })

      if (preDefinedOptions.includes(item.PadValue)) {
        this.form.Pad = item.PadValue
        this.customPad = {
          enable: false,
          value: null,
          pluralValue: null
        }
      } else {
        this.form.Pad = null
        this.customPad = {
          enable: true,
          value: item.PadValue,
          pluralValue: item.PluralPadValue
        }
      }
    },
    resetOptions() {
      this.dateTimeFormatOptions = []
      this.weightMetricOptions = []
      this.temperatureMetricOptions = []
    },
    async getConfigs() {
      this.loading = true
      ApiService.GetOrganisationSettingConfigs()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.resetOptions()
            let data = response.data.data
            this.dateTimeFormatOptions = data.DateTimeFormat.map(item => {
              return {
                value: item.value,
                label: item.value + ` (eg: ${item.label})`
              }
            })
            this.measureUnitOptions = data.MeasuringUnit
            this.padOptions = data.Pad
            this.patientOptions = data.Patient
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    async getAllLocation() {
      this.loading = true
      ApiService.GetAllLocation()
        .then(response => {
          this.loading = false
          this.timeZoneList = response.data.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    getDetail() {
      this.loading = true
      ApiService.GetOrganisationSettings(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            let data = response.data.data
            if (data) {
              this.form = {
                Language: this.getInitLanguage(),
                TimeZone: data.TimeZone,
                DateTimeFormat: data.DateTimeFormat,
                MeasuringUnit: data.MeasuringUnit,
                Pad: '',
                Patient: '',
                IsTimeDisplayEnabled: data.IsTimeDisplayEnabled,
                OrganisationCode: this.form.OrganisationCode
              }
              this.savedPadTexts = data.Pad
              this.savedPatientTexts = data.Patient
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    getOrganisationSetupCode() {
      this.loading = true
      ApiService.GetOrganisationSetupCode(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            let data = response.data.data
            this.form.OrganisationCode = data.Code
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    generateNewCode() {
      this.generateLoading = true
      ApiService.GenerateOrganisationSetupCode({
        OrganisationId: this.$store.getters[`user/selecteOrganisationId`]
      })
        .then(response => {
          this.generateLoading = false
          if (response.data.success) {
            let data = response.data.data
            this.form.OrganisationCode = data.Code
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.generateLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    resetForm() {
      this.$refs['form'].resetFields()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveSettings()
        }
      })
    },
    saveSettings() {
      let selectedPadTerm = this.padOptions.filter(item => {
        return item[this.form.Language]['singular'] === this.form.Pad
      })
      let selectedPatientTerm = this.patientOptions.filter(item => {
        return item[this.form.Language]['singular'] === this.form.Patient
      })
      if (
        !selectedPadTerm.length &&
        !(this.customPad.value && this.customPad.pluralValue)
      ) {
        swal({
          icon: 'warning',
          title: 'Warning',
          text: this.$t('text.pad_term_not_select_warning')
        })
        return false
      }
      if (
        !selectedPatientTerm.length &&
        !(this.customPatient.value && this.customPatient.pluralValue)
      ) {
        swal({
          icon: 'warning',
          title: 'Warning',
          text: this.$t('text.patient_term_not_select_warning')
        })
        return false
      }
      this.submitLoading = true
      let params = {
        OrganisationId: this.$store.getters[`user/selecteOrganisationId`],
        Language: this.form.Language,
        TimeZone: this.form.TimeZone,
        DateTimeFormat: this.form.DateTimeFormat,
        MeasuringUnit: this.form.MeasuringUnit,
        IsTimeDisplayEnabled: this.form.IsTimeDisplayEnabled,
        Pad: this.form.Pad,
        Patient: this.form.Patient,
        PluralPad:
          selectedPadTerm && selectedPadTerm.length
            ? selectedPadTerm[0][this.form.Language]['plural']
            : '',
        PluralPatient:
          selectedPatientTerm && selectedPatientTerm.length
            ? selectedPatientTerm[0][this.form.Language]['plural']
            : ''
      }
      if (this.customPad.enable) {
        params.Pad = this.customPad.value
        params.PluralPad = this.customPad.pluralValue
      }
      if (this.customPatient.enable) {
        params.Patient = this.customPatient.value
        params.PluralPatient = this.customPatient.pluralValue
      }
      ApiService.SaveOrganisationSettings(params)
        .then(response => {
          this.submitLoading = false
          if (response.data.success) {
            this.$store.dispatch('locale/getCustomTerms')
            this.getDetail()
            this.$store.commit(
              'customization/SET_IS_TIME_DISPLAY_ENBLED',
              this.form.IsTimeDisplayEnabled
            )
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.submitLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleLanguageChange() {
      this.$store.dispatch('locale/saveLocale', this.form.Language)
    },
    // organisation shifts
    openAddRoundDialog() {
      this.$refs.addRound.openDialog()
    },
    editRoundItem(item) {
      this.$refs.addRound.openDialog()
      this.$refs.addRound.form = {
        id: item.Id,
        name: item.ShiftName,
        round: [
          moment('2023-10-27 ' + item.ShiftStart).valueOf(),
          moment('2023-10-27 ' + item.ShiftEnd).valueOf()
        ]
      }
    },
    removeRoundItem(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.you_are_about_to_remove_this_item'
        )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.yes').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.handleDeleteRound(item)
      })
    },
    handleDeleteRound(item) {
      this.shiftLoading = true
      ApiService.DeleteOrgShif(item.Id)
        .then(response => {
          this.shiftLoading = false
          if (response.data.success) {
            this.getRounds()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.shiftLoading = false
        })
    },
    async getRounds() {
      this.shiftLoading = true
      await ApiService.GetOrganisationShift(
        this.$store.getters[`filter/calculatedFilter`].organisationId
      )
        .then(response => {
          this.shiftLoading = false
          if (response.data.success) {
            this.roundsList = response.data.data
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed')
            })
          }
        })
        .catch(() => {
          this.shiftLoading = false
          swal({
            icon: 'error',
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
